import React, { useEffect, useState } from 'react';
import Nav from '../../components/Nav';
import DinamicTable from '../../components/DinamicTable';
import DashboardSidebar from '../../components/DashboardSidebar';
import ApiService from '../../services/ApiService';
import formatDate from '../../services/formatDate';

const OrderList = () => {

    const [active, setActive] = useState(true);
    const [orders, setOrders] = useState([]);
    const [filter, setFilter] = useState({ page: 1, pages: 0, limit: 5, isLoading: false, search: '' });

    const tableColumns = ["#", "User", "Amount", "Paid", "Created at", "Expiring at", "Action"];

    const getOrders = async () => {
        try {
            setFilter((prev) => { return { ...prev, isLoading: true } });
            const response = await ApiService.get(`/cms/orders?page=${filter?.page}&limit=${filter?.limit}&user_name=${filter?.search}`);

            setFilter((prev) => { return { ...prev, pages: response?.totalPages } });
            setOrders(response?.contents?.map(order => {
                return {
                    _id: order?._id,
                    user: order?.data?.user_name || "N/A",
                    amount: `${order?.data?.amount} ${order?.data?.currency}` || "N/A",
                    paid: !!(order?.data?.status == 'succeeded'),
                    createdAt: formatDate(order?.createdAt, false) || "N/A",
                    expiring_at: formatDate(order?.data?.expiring_at, false) || "N/A",
                };
            }) || []);
        } catch (err) {
            console.error("Error fetching orders:", err);
        } finally {
            setFilter((prev) => { return { ...prev, isLoading: false } });
        }
    };

    useEffect(() => {
        if (filter?.isLoading === false) {
            getOrders();
        }
    }, [filter?.page, filter?.search]);

    return (
        <div className="tyn-root dashboard">
            <Nav />
            <div className="tyn-content tyn-content-full-height tyn-chatbot tyn-chatbot-page has-aside-base">
                <DashboardSidebar active='Order List' setter={setActive} />
                <div className={`tyn-main tyn-content-inner ${active && 'main-shown' || ''}`} id="tynMain">
                    <ul className="tyn-list-inline d-md-none translate-middle position-absolute start-50 z-1">
                        <li>
                            <button className="btn btn-icon btn-pill btn-white js-toggle-main" onClick={() => setActive(false)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                </svg>
                            </button>
                        </li>
                    </ul>
                    <DinamicTable
                        data={orders}
                        title="Order List"
                        tableColumns={tableColumns}
                        filter={filter}
                        setFilter={setFilter}
                        editLink="/dashboard/orders/"
                    />
                </div>
            </div>
        </div>
    );
};

export default OrderList;
